import React, { useRef } from 'react';
import ChartControls from '../ui/ChartControls';
import { CHART_GUIDES } from '../../constants/chartGuides';

interface SalesTrendHeaderProps {
  componentId: string;
  componentTitle: string;
  branchId: number;
  timeRange?: string;
  compact?: boolean;
  showComparisonView: boolean;
  showNormalizedView: boolean;
  onOpenGuide: () => void;
  onFavoriteToggle: () => void;
  isFavorited: boolean;
  onToggleComparisonView: () => void;
  chartRef?: React.RefObject<HTMLElement>;
  onToggleNormalizedView: () => void;
}

const SalesTrendHeader: React.FC<SalesTrendHeaderProps> = ({
  componentId,
  componentTitle,
  branchId,
  timeRange = 'last6Months',
  compact = false,
  showComparisonView,
  showNormalizedView,
  onOpenGuide,
  onFavoriteToggle,
  isFavorited,
  onToggleComparisonView,
  chartRef,
  onToggleNormalizedView,
}) => {
  return (
    <div className="mb-6">
      <ChartControls
        componentId={componentId}
        componentTitle={componentTitle}
        componentType="chart"
        dashboardSource="mainPerformance"
        onInfo={onOpenGuide}
        onFavorite={onFavoriteToggle}
        isFavorited={isFavorited}
        chartRef={chartRef}
        className="mb-4"
      />
      <h3 className="title-card">{componentTitle}</h3>

      <div className="sales-trend-controls mt-3">
        <p className="text-text-secondary text-sm text-center lg:text-right">
          {showComparisonView
            ? 'مقایسه روند فروش شعبه با میانگین برند'
            : showNormalizedView
              ? 'مقایسه روند مبلغ فروش و تعداد سفارش'
              : 'نمایش جداگانه مبلغ فروش و تعداد سفارش'
          }
        </p>
        <div className="sales-trend-toggle-row lg:flex lg:flex-wrap lg:justify-end">
          <button
            onClick={onToggleComparisonView}
            className="px-4 py-2 text-sm font-medium text-text-primary bg-bg-secondary hover:bg-bg-tertiary border border-border-primary rounded-lg transition-colors flex items-center gap-2"
          >
            <span>{showComparisonView ? '📊' : '🏢'}</span>
            {showComparisonView ? 'نمایش داخلی' : 'مقایسه با برند'}
          </button>
          {!showComparisonView && (
            <button
              onClick={onToggleNormalizedView}
              className="px-4 py-2 text-sm font-medium text-text-primary bg-bg-secondary hover:bg-bg-tertiary border border-border-primary rounded-lg transition-colors flex items-center gap-2"
            >
              <span>{showNormalizedView ? '📊' : '📈'}</span>
              {showNormalizedView ? 'نمایش جداگانه' : 'نمایش مقایسه‌ای'}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default SalesTrendHeader;